import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../../Box/Box.js';
import { pricePartsToString } from '../PriceHelper.js';
import { ScreenReaderOnly } from '../../ScreenReaderOnly/ScreenReaderOnly.js';
import { Typography } from '../../Typography/Typography.js';

var _excluded = ["price", "srOnlyLeadingText"];
var Crossout = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var price = _ref.price,
    srOnlyLeadingText = _ref.srOnlyLeadingText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var crossoutPrice = Array.isArray(price) ? pricePartsToString(price) : price;

  // Need to manually add space between currency and value since we need to wrap both under the same text-decoration line-through
  var crossoutPriceText = crossoutPrice.amount;
  if (crossoutPrice.alignCurrency === 'end') {
    crossoutPriceText = "".concat(crossoutPriceText, " ").concat(crossoutPrice.currency);
  } else {
    crossoutPriceText = "".concat(crossoutPrice.currency, " ").concat(crossoutPriceText);
  }
  return /*#__PURE__*/React.createElement(Box, _extends({
    dir: "ltr" // Do not flip currency for crossout
    ,
    display: "inline-flex",
    alignItems: "baseline",
    flexDirection: "row"
  }, rest, {
    ref: ref
  }), srOnlyLeadingText && /*#__PURE__*/React.createElement(ScreenReaderOnly, null, "".concat(srOnlyLeadingText, ": ").concat(crossoutPriceText)), /*#__PURE__*/React.createElement(Typography, _extends({
    "data-testid": "crossout-price",
    tag: "span",
    variant: "caption-default",
    textColor: "base.subtle",
    textDecoration: "line-through"
  }, srOnlyLeadingText ? {
    'aria-hidden': true
  } : undefined), crossoutPriceText));
});
var CrossoutMemoized = /*#__PURE__*/React.memo(Crossout);
CrossoutMemoized.displayName = 'Crossout';

export { CrossoutMemoized as Crossout, Crossout as CrossoutWithoutMemoized };
//# sourceMappingURL=Crossout.js.map
